import Card from "./components/Card";


function App() {
  return (
    <div className="App">
      <Card />
    </div>
  );
}

export default App;
